<template>
  <div class="col-12 cart-popup" v-if="active" v-click-outside="hide">
    <template v-if="cart.purchases.length">
      <div class="cart-popup__list">
        <div class="d-flex align-items-center justify-content-between cart-popup__item" :class="{'is-loading': loading}" v-for="purchase in purchases">
          <div class="cart-popup__image">
            <img :src="purchase.product.thumb_url || '/img/no-image-available.png'" :alt="purchase.product.name">
          </div>

          <div class="cart-popup__name">
            {{purchase.product.name}}
          </div>

          <div class="cart-popup__qty-info">
            <div class="cart-popup__price">
              <price-formatted :value="purchase.base_price !== null ? purchase.base_price * purchase.amount : purchase.product.price * purchase.amount"/>
            </div>

            <div class="cart-popup__per-total">
              {{purchase.amount}} x <price-formatted :value="purchase.product.price"/>
            </div>
          </div>

          <div class="cart-popup__remove" @click="remove_product(purchase)">
            <svg-icon icon="close-remove"></svg-icon>
          </div>
        </div>
      </div>

      <a :href="route('cart')" class="button-green cart-popup__button">Перейти в корзину</a>
    </template>

    <template class="cart-popup__products" v-else>
      <div class="cart-popup__no-products">В корзине еще ничего нет. <a :href="route('store')">Перейти в каталог</a></div>
    </template>
  </div>
</template>

<script>
  import API from '../../api'
  import Analytics from '../../../modules/Analytics'
  import $ from 'jquery'

  export default {
    data() {
      return {
        active : false,
        cart : window.CART_FULL,
        loading : false,
      }
    },
    created() {

    },
    mounted() {

    },
    methods : {
      toggle() {
        this.active = !this.active
      },
      hide() {
        this.active = false
      },
      updateCart(new_cart) {
        Object.assign(this.cart, new_cart)
      },
      remove_product(purchase) {
        this.loading = true

        API.cart.remove(purchase.product.id, purchase.payload && purchase.payload.hash)
          .then((cart) => {

            let $elemProductAddButton = $(`.js-add-to-cart[data-product-id=${purchase.product.id}]`)
            if ($elemProductAddButton.data('type') === 'product-list') {
              $elemProductAddButton = $elemProductAddButton.parent()
            }

            $elemProductAddButton.removeClass('d-none').next().addClass('d-none')
            this.loading = false
            this.updateCart(cart)
          })

        //Analytics.ecommerce_cart_remove(purchase.product.id, purchase.product.name, purchase.amount)
      },
    },
    computed: {
      product_ids() {
        return this.cart.purchases.map(purchase => purchase.product.id)
      },
      product_ids_by_id() {
        return this.product_ids.reduce((res, cur) => { res[cur] = cur; return res }, {})
      },
      purchases() {
        return this.cart.purchases.sort((a,b) => {
          const price_a = parseFloat(a.product.price)
          const price_b = parseFloat(b.product.price)
          if (price_a === price_b) return 0
          return price_a > price_b ? -1 : 1
        })
      }
    },
    components: {

    },
    watch : {
      ['cart.total_products'](newVal) {
        $('.js-cart-counter').text(newVal)
      }
    },
  }
</script>
